import { useState } from "react";
import { FileInputPdf } from "../../../../common/components/form/FileInputPdf";
import { updateVehicleProps } from "../../../../common/services/vehicles.api";
import { CrlvDocument, IVehicle } from "../../../../types/vehicle.type";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import ModalCrlv from "./Modals/ModalCrlv";

type VehicleDocumentProps = {
  vehicleId: string;
  crlvDocs: CrlvDocument[];
  crlv?: string;
  currentNFPath: string;
  filesSale: string | undefined;
  status: string;
  onVehicleUpdate: (updatedData: Partial<IVehicle>) => void;
};

export default function VehicleDocumentsRow(props: VehicleDocumentProps) {
  const { onVehicleUpdate } = props;
  const pathToUpload = `vehicles/${props.vehicleId}`;
  const [isModalCrlvOpen, setIsModalCrlvOpen] = useState(false);
  const { showToast } = useToastContext();

  const saveVehicleCRLV = async (crlvDocs: CrlvDocument[]) => {
    await updateVehicleProps(props.vehicleId, {
      crlvDocs,
    });
    onVehicleUpdate({ crlvDocs });
  };

  const saveVehicleNF = async (nf) => {
    await updateVehicleProps(props.vehicleId, {
      nf,
    });
    onVehicleUpdate({ nf });
    showToast({ text: "Nota Fiscal salva!", type: "success" });
  };

  const saveFileSale = async (filesSale) => {
    await updateVehicleProps(props.vehicleId, {
      filesSale,
    });
    onVehicleUpdate({ filesSale });
    showToast({ text: "Contrato/NF de Venda salvo!", type: "success" });
  };

  return (
    <div className="col-span-3 bg-gray/40 p-4 rounded-md">
      <h2 className="text-2xl font-semibold mb-4">
        Enviar documentos do veículo
      </h2>
      <div className="flex flex-col items-stretch">
        <h3 className="font-bold ml-2">CRLV</h3>

        <div className="flex flex-col items-start ">
          <button
            onClick={() => setIsModalCrlvOpen(true)}
            className="m-2 bg-redPrimary text-white "
          >
            Gerenciar CRLV
          </button>
          <div className="mt-3 ml-3 text-base w-full">
            {!props.crlvDocs || props.crlvDocs.length === 0 ? (
              <a
                href={`https://assets.locavibe.com.br/${props.crlv}`}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-2 bg-white text-black-800 rounded-full font-semibold text-base hover:bg-red-500 transition-colors cursor-pointer inline-flex items-center"
              >
                CRLV Antigo
                <svg
                  className="inline-block w-5 h-5 ml-1 text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 26 26"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                  ></path>
                </svg>
              </a>
            ) : (
              <div className="flex flex-wrap gap-2">
                <span className="font-semibold text-base self-center">
                  Documentos Salvos:
                </span>
                {props.crlvDocs.map((doc) => (
                  <a
                    key={doc.year}
                    href={`https://assets.locavibe.com.br/${doc.crlv}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 py-2 bg-white text-black-800 rounded-full font-semibold text-base hover:bg-red-500 transition-colors cursor-pointer"
                  >
                    {doc.year}{" "}
                    <svg
                      className="inline-block w-5 h-5 ml-1 text-green-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 26 26"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 14l-7 7m0 0l-7-7m7 7V3"
                      ></path>
                    </svg>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        {isModalCrlvOpen && (
          <ModalCrlv
            vehicleId={props.vehicleId}
            pathToUpload={pathToUpload}
            currentCrlvDocs={props.crlvDocs || []}
            onSave={saveVehicleCRLV}
            onClose={() => setIsModalCrlvOpen(false)}
          />
        )}
        <h3 className="font-bold ml-2 mt-4">Nota Fiscal</h3>
        <FileInputPdf
          onChange={saveVehicleNF}
          pathToUpload={pathToUpload}
          currentPath={props.currentNFPath}
          nameFile="Enviar Nota Fiscal"
        />

        {props.status === "selled" && typeof props.filesSale == "string" && (
          <>
            <h3 className="font-bold ml-2 mt-4 ">Contrato/NF de Venda</h3>
            <FileInputPdf
              onChange={saveFileSale}
              pathToUpload={pathToUpload}
              currentPath={props.filesSale}
              nameFile="Enviar contrato/NF de Venda"
            />
          </>
        )}
      </div>
    </div>
  );
}
